import { render, staticRenderFns } from "./urusan.vue?vue&type=template&id=1af8f14a&"
import script from "./urusan.vue?vue&type=script&lang=js&"
export * from "./urusan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports